import { SVG_ENUM } from "../../enums";
import Table from "rc-table";
import React, { useState, useEffect } from "react";
import { Button, Pagination, SVG, ConfirmationModal } from "../../shared";
import { UserType } from "../../types/UsersTypes";
import useGetUsers from "hooks/users/GetUsersHook";
import { useSuspend } from "../../hooks/users";
import { AddEditUserModal } from "../../features";
import "./UsersPage.scss";

type UsersPageProps = {};

const UsersPage: React.FC<UsersPageProps> = () => {
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserType | null>(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [userToSuspend, setUserToSuspend] = useState<UserType | null>(null);
  const { data, refetch } = useGetUsers(page);
  const { mutate: suspendUser } = useSuspend({
    onSuccess: () => refetch(),
  });
  useEffect(() => {}, [page]);

  const handleAddUser = () => {
    setSelectedUser(null);
    setIsModalOpen(true);
  };

  const handleEditUser = (user: UserType) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleSuspendUser = (user: UserType) => {
    setUserToSuspend(user);
    setIsConfirmModalOpen(true);
  };

  const confirmSuspendUser = () => {
    if (userToSuspend) {
      suspendUser(userToSuspend.uuid);
      setIsConfirmModalOpen(false);
      setUserToSuspend(null);
    }
  };

  const getStatusDisplay = (user: UserType) => {
    if (user.suspended) {
      return <span className="badge badge--suspended">Zablokowany</span>;
    } else if (user.activate) {
      return <span></span>;
    } else {
      return <span className="badge badge--inactive">Nieaktywny</span>;
    }
  };

  const handleModalSuccess = () => {
    refetch();
  };

  const Columns = () => [
    { title: "IMIE I NAZWISKO", dataIndex: "name", key: "name" },
    { title: "EMAIL", dataIndex: "email", key: "email" },
    { title: "ROLA", dataIndex: "role", key: "role" },
    {
      dataIndex: "status",
      key: "status",
      render: (_: any, record: UserType) => getStatusDisplay(record),
    },
    {
      key: "actions",
      render: (_: any, record: UserType) => (
        <div className="users__settings">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleSuspendUser(record)}
          >
            <SVG
              type={
                record.suspended ? SVG_ENUM.SQUARE_CHECK : SVG_ENUM.STOP_SIGN
              }
            />
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleEditUser(record)}
          >
            <SVG type={SVG_ENUM.EDIT} />
          </div>
        </div>
      ),
    },
  ];

  const MobileColumns = () => [
    { title: "Użytkownik", dataIndex: "name", key: "name" },
  ];

  return (
    <div>
      <div className="prices-page__header">
        <h1>Lista Użytkowników</h1>
        <Button
          label="Dodaj użytkownika"
          onClick={handleAddUser}
          styleType="primary"
        />
      </div>
      <Table
        rowKey="id"
        className="prices-table desktop-table"
        data={data?.data}
        columns={Columns()}
      />

      <Table
        rowKey="id"
        className="companies-table mobile-table"
        data={data?.data}
        columns={MobileColumns()}
        showHeader={false}
      />

      {data?.meta && data?.meta?.lastPage > 1 && (
        <Pagination
          totalPages={data?.meta?.lastPage}
          currentPage={data?.meta?.currentPage || page}
          onPageChange={(e: any) => setPage(e)}
        />
      )}

      <AddEditUserModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleModalSuccess}
        user={selectedUser}
      />

      <ConfirmationModal
        isOpen={isConfirmModalOpen}
        onClose={() => {
          setIsConfirmModalOpen(false);
          setUserToSuspend(null);
        }}
        onConfirm={confirmSuspendUser}
        title={
          userToSuspend?.suspended
            ? "Odblokowanie użytkownika"
            : "Blokowanie użytkownika"
        }
        // message={`Czy jesteś pewien, że chcesz ${
        //   userToSuspend?.suspended ? "odblokować" : "zablokować"
        // } użytkownika ${userToSuspend?.name} (${userToSuspend?.email})?`}
        message={
          <p>
            Czy jesteś pewien, że chcesz{" "}
            {userToSuspend?.suspended ? "odblokować" : "zablokować"} użytkownika{" "}
            <strong>{userToSuspend?.name}</strong> ({userToSuspend?.email})?
          </p>
        }
        confirmLabel={userToSuspend?.suspended ? "Odblokuj" : "Zablokuj"}
        cancelLabel="Anuluj"
      />
    </div>
  );
};

export default UsersPage;
